/*
 * Copyright Huesik (c) 2019.
 */

const KosiwonConstant = {
  HEATING_TYPE: {
    'C': '중앙난방',
    'S': '개별난방',
    'N': '정보없음'
  },
  ROOM_TYPE: {
    'M': '미니룸',
    'S': '샤워룸',
    'O': '원룸'
  },
  USE_SEX_TYPE: {
    'U': '남녀공용',
    'M': '남성전용',
    'W': '여성전용',
    'S': '남녀층분리'
  },
  LAST_VIEW_LIST_MAX_COUNT: 16,
  OPTION_NAME: {

  }
}

export default KosiwonConstant
